import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BooleanPipe } from './boolean.pipe';
import { CustomDateTimePipe } from './custom-datetime.pipe';
import { CustomNumberPipe } from './custom-number.pipe';
import { CustomPercentPipe } from './custom-percent.pipe';
import { CustomPlaceholderPipe } from './custom-placeholder.pipe';
import { DynamicPipe } from './dynamic.pipe';
import { HashToArrayPipe } from './hash-to-array.pipe';
import { MapToIterablePipe } from './map-to-iterable.pipe';
import { TextHighlightPipe } from './text-highlight.pipe';

const DECLARE_AND_EXPORT = [
    CustomNumberPipe,
    CustomPercentPipe,
    CustomDateTimePipe,
    CustomPlaceholderPipe,
    MapToIterablePipe,
    DynamicPipe,
    HashToArrayPipe,
    BooleanPipe,
    TextHighlightPipe
];

@NgModule({
    imports: [CommonModule],
    declarations: DECLARE_AND_EXPORT,
    exports: DECLARE_AND_EXPORT,
    providers: [DynamicPipe, CustomNumberPipe]
})
export class PipeModule {
}
